import { createIndex, selectMany } from "../omnia"
import { FieldAnalysis } from "./analysis/type"
import { PlanApi } from "./api"
import { setupObservations } from "./observations/manager"
import { getObservationActionsProvider } from "./observations/observations"
import { PlanAction, selectField } from "./reducer"
import { PlanApiData, PlanField, PlanState } from "./types"

export function createInitialState(api: PlanApi): PlanState {

    const { year } = api

    return {

        year,
        loading: true,

        selectedField: undefined,

        plans: [],

        fields: {},

        observations: {
            actions: {},
            observations: {},
            obsActionsProvider: id => undefined,
        },

        userObservations: [],

        analysis: {
            std: [],
            sa: [],
            hsa: []
        },

        settings: {
            predefsFilter: "",
            analysis: {
                unit: api.unit,
                expandGroups: false
            }
        }

    }

}

export function loadApiData(state: PlanState, data: PlanApiData): PlanState {

    const { selectedField } = state
    const { observations: { observations, actions }, analysis, fields } = data

    const fieldId = selectedField?.fieldId

    const reference = {
        observations: createIndex(observations, o => o.id),
        actions: createIndex(actions, a => a.id),
    }

    state = {

        ...state,

        year: data.year,
        loading: false,

        plans: data.plans,

        fields: createIndex(fields, f => f.fieldId),

        observations: {
            ...reference,
            obsActionsProvider: getObservationActionsProvider(reference)
        },

        userObservations: setupObservations(data.userObservations?.observations),

        analysis

    }

    state = selectField(state, fieldId)

    return state

}


export function saveField(state: PlanState, dispatch: React.Dispatch<PlanAction>, api: PlanApi) {

    const { selectedField: { fieldId, year, observations, analysis } } = state

    type AnalysisType = "std" | "hsa" | "sa"

    function getAnalysis(type: AnalysisType, id: number) {
        return {
            type,
            id,
            report: false
        }
    }

    function getAnalysisList<T extends { key: number, selected: { value: boolean } }>(type: AnalysisType, items: T[]) {
        return items.filter(i => !(i.selected?.value)).map(i => getAnalysis(type, i.key))
    }

    const analyses: FieldAnalysis[] = selectMany(

        analysis.std
            .filter(s => !s.selected.value)
            .map(s => s.items.map(i => getAnalysis("std", i.key))

            )
            .concat(
                getAnalysisList("sa", analysis.sa)
            )
        // 220608 - Not used anymore, healthy soil assessments are not included in soil mgmt plans
        // .concat(
        //     getAnalysisList("hsa", analysis.hsa)
        // )

    )

    const field: PlanField = {
        fieldId,
        year,
        observations: observations.filter(o => !o.deleted),
        analyses
    }

    return api.saveField(field).then(field => dispatch({ type: "refreshField", field }))

}

